var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm._f("trans")("adminTopicTitle"))+"\n        ")])]),_c('div',{staticStyle:{"width":"50%"}},[_c('topic-admin')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }